/**
 * @deprecated Renamed to email stationery
 */
export const previewTypeEvoucher = 'evoucher';
export const previewTypeOverprint = 'overprint';
